const CENTS_START_INDEX = -2;

const formatDollars = (dollars: string, cents: string): string => `$${dollars}.${cents}`;
const formatWithoutCurrency = (dollars: string, cents: string): string => `${dollars}.${cents}`;

export const centsToDollars = (cents: number, currencyFormatter = formatDollars): string => {
  if (!Number.isInteger(cents)) {
    throw new Error('Dont use floats for currency');
  }

  if (cents === 0) {
    if (currencyFormatter === formatWithoutCurrency) {
      return '0.00';
    }
    return '$0.00';
  }
  const parsedCents = cents.toString();
  const isDiscount = cents < 0 && parsedCents.length < 4;
  const dollarsString = isDiscount ? '-0' : parsedCents.slice(0, CENTS_START_INDEX) || '0';
  const centsString = cents.toString().slice(CENTS_START_INDEX);
  return currencyFormatter(dollarsString, centsString);
};
